import { PrebuiltTemplateShowcase } from '@/components/PrebuiltTemplateShowcase';

export function TemplateLibrary({
  defaultTab = 'gallery',
}: {
  defaultTab?: 'gallery' | 'comparison' | 'learning';
}) {
  return <PrebuiltTemplateShowcase showHero={false} defaultTab={defaultTab} />;
}
